// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 883 ? "LoginPage" : chunkId) + "." + {"99":"54096e2c","883":"145345fc"}[chunkId] + ".chunk.js";
};